import React, { FormEventHandler } from 'react';

function XIcon(props: { className?: string, onClick?: FormEventHandler }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            // className="h-20 w-20 from-blue-500 to-blue-200"
            className={`${props.className}`}
            viewBox="0 0 1280.000000 1280.000000"
            preserveAspectRatio="xMidYMid meet"
            stroke="url(#grad1)"
            fill="url(#grad1)"
        >
            <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">
                <defs>
                    <linearGradient
                        id="grad1"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                    >
                        <stop
                            offset="0%"
                            style={{ stopColor: '#3b82f6', stopOpacity: 1 }}
                        />
                        <stop
                            offset="100%"
                            style={{ stopColor: '#bae6fd', stopOpacity: 1 }}
                        />
                    </linearGradient>
                </defs>
                <path d="M2775 12790 c-202 -30 -409 -130 -645 -313 -139 -109 -444 -413 -727 -727 -148 -164 -324 -344 -494 -506 -145 -138 -316 -305 -379 -370 -553 -572 -667 -1038 -365 -1500 184 -283 388 -501 925 -992 230 -209 599 -569 1175 -1144 l840 -838 -1361 -1362 c-748 -750 -1383 -1390 -1411 -1423 -400 -477 -436 -879 -121 -1348 126 -188 308 -376 728 -754 273 -246 361 -334 703 -705 336 -364 575 -576 779 -691 315 -176 642 -151 996 77 178 114 284 216 1629 1560 l1353 1351 1347 -1346 c742 -740 1387 -1380 1435 -1421 178 -154 365 -262 533 -309 63 -18 107 -23 210 -23 170 -1 264 22 440 109 243 120 448 300 849 745 305 340 339 374 701 710 419 388 578 559 716 769 82 124 125 224 150 346 22 104 23 162 8 272 -27 198 -126 400 -312 638 -43 55 -604 624 -1426 1448 l-1356 1357 1361 1363 c748 749 1383 1389 1411 1422 151 180 250 350 299 511 24 77 27 107 28 224 0 152 -21 258 -78 385 -124 277 -288 467 -836 965 -338 308 -358 327 -692 690 -345 375 -519 536 -720 667 -190 125 -319 167 -508 167 -164 1 -279 -28 -440 -109 -253 -128 -275 -147 -1768 -1639 l-1352 -1351 -909 910 c-632 633 -976 986 -1131 1160 -367 412 -638 669 -855 813 -260 172 -510 245 -730 212z" />
            </g>
        </svg>
    );
}

export default XIcon;
